import AssociatedTermsSelector from './src/main';

/* istanbul ignore next */
AssociatedTermsSelector.install = function(Vue) {
  Vue.component(AssociatedTermsSelector.name, AssociatedTermsSelector);
};

export default AssociatedTermsSelector;
